<template>
  <div class="app-container">
    <navigation></navigation>
    <div class="main">
      <van-notice-bar
          left-icon="volume-o"
          :text="noticeList.title"
          color="#CB0A0A"
          class = 'notice'
          v-if = "noticeList"
          @click = 'goDetail(noticeList.id,noticeList.informationType)'
      >
        <template #left-icon>
          <svg-icon iconClass='notice' className='icon' class="notice-icon"></svg-icon>
        </template>
      </van-notice-bar>
      <div class="banner">
        <van-swipe class="my-swipe" :autoplay="3000" :lazy-render = 'true' indicator-color="white">
          <van-swipe-item v-for="item in bannerList">
            <img :src="baseUrl+item.coverPath" alt="" class="banner-img" @click="goBanner(item)">
          </van-swipe-item>
        </van-swipe>
        <van-search placeholder="请输入关键词" @focus="onSearch" center class="serach"/>
      </div>
      <div class="trailer-box" v-if="lectureList.length>0 && isShowList.hasOwnProperty('近期预告')">
        <div>
          <span class="custom-title">近期预告<span class="custom-bar"></span></span>
        </div>
        <van-swipe vertical autoplay="3000" :touchable="false" class="trailer-swipe">
          <van-swipe-item v-for="item in lectureList">
            <van-cell is-link  to="trailer" class="trailer-title-bg" center>
              <template #title>
                <div class="title-trailer">
                  <img src="@/assets/img/list-news.png" alt="" class="news">
                  <span class="custom-title-little">{{ item.title }}</span>
                </div>
              </template>
              <template #right-icon>
              </template>
            </van-cell>
          </van-swipe-item>
          <template #indicator>
            <span></span>
          </template>
        </van-swipe>
        <span class="custom-more"></span>
      </div>
      <div class="model-flex">
        <div ref="trailer" :style="{order:isShowList['最新资讯'].sort}" class="trailer" v-if="isShowList.hasOwnProperty('最新资讯')">
          <div class="trailer-content">
            <div class="trailer-sides"><span class="trailer-title">最新资讯</span></div>
            <div class="trailer-content-list">
              <van-cell v-for="item in informationList" @click="goDetail(item.id,item.informationType)" class="trailer-cell">
                <template #title>
                  <div class="cell-title">
                    <span class="trailer-icon"></span>
                    <span class="trailer-list-title">{{ item.title }}</span>
                  </div>
                </template>
                <template #label>
                  <span class="cell-label">{{ item.informationType }}</span>
                  <span>{{ item.startTime }}</span>
                </template>
              </van-cell>
            </div>
            <div class="trailer-sides"><span class="trailer-more" @click="goInformation">查看更多</span></div>
          </div>
        </div>
        <div ref="poetryRead" :style="{order:isShowList['文津经典诵读'].sort}" class="poetryRead" v-if="isShowList.hasOwnProperty('文津经典诵读')">
          <van-cell is-link to="poetryRead" center>
            <template #title>
              <span class="model-title">文津经典诵读</span>
            </template>
            <template #right-icon>
              <div class="more-parent">
                <span class="more-val">更多</span>
              </div>
            </template>
          </van-cell>
          <div class="poetryRead-content">
            <van-tabs title-inactive-color="#333" animated>
              <van-tab title="诗词名句">
                <div class="today">
                  <div class="today-left">
                    <p v-if="poetry.dateInfo">{{poetry.dateInfo.yearMonth}}</p>
                    <p v-if="poetry.dateInfo" class="date-today">{{poetry.dateInfo.dayOfMonth}}</p>
                    <p v-if="poetry.dateInfo" class="weekday">{{poetry.dateInfo.dayOfWeek}}</p>
                    <p v-if="poetry.dateInfo" class="calendar">农历{{poetry.dateInfo.chineseDay}}</p>
                    <p v-if="poetry.dateInfo" class="calendar">{{poetry.dateInfo.chineseYear}}</p>
                  </div>
                  <div class="today-right">
                    <div class="detail-scroll">
                      <van-notice-bar scrollable delay="3" :text="poetry.sectionText"/>
                    </div>
                    <p class="source">—{{ poetry.title ? poetry.title : '' }}</p>
                    <p class="year-author">{{poetry.year?'（'+poetry.year +'）': '' }}{{ poetry.author }}</p>
                  </div>
                  <div class="today-audio">
                    <audio ref="todayAudio" :src="baseUrl+poetry.audioPath" type="audio/mpeg"></audio>
                    <p class="play" v-if="todayPlay" @click="play"></p>
                    <p class="pause"v-else @click="pause"></p>
                  </div>
                </div>
              </van-tab>
              <van-tab title="美德格言">
                <div class="motto">
                  <div class="today">
                    <div class="today-left">
                      <p v-if="poetry.dateInfo">{{poetry.dateInfo.yearMonth}}</p>
                      <p v-if="poetry.dateInfo" class="date-today">{{poetry.dateInfo.dayOfMonth}}</p>
                      <p v-if="poetry.dateInfo" class="weekday">{{poetry.dateInfo.dayOfWeek}}</p>
                      <p v-if="poetry.dateInfo" class="calendar">农历{{poetry.dateInfo.chineseDay}}</p>
                      <p v-if="poetry.dateInfo" class="calendar">{{poetry.dateInfo.chineseYear}}</p>
                    </div>
                    <div class="today-right">
                      <div class="detail-scroll">
                        <van-notice-bar scrollable delay="3" :text="poetry.mottoSection"/>
                      </div>
                      <p class="source">—{{ poetry.mottoTitle? poetry.mottoTitle :'' }}</p>
                      <p class="year-author">{{poetry.mottoYear?'（'+poetry.mottoYear +'）': '' }}{{ poetry.mottoAuthor }}</p>
                    </div>
                    <div class="today-audio" v-if="poetry.mottoAudio" @click="mottoAudio">
                      <audio ref="motto" :src="baseUrl+poetry.mottoAudio" ></audio>
                      <p class="play" v-if="mottoPlay"></p>
                      <p class="pause"v-else></p>
                    </div>
                  </div>
                </div>
              </van-tab>
            </van-tabs>
          </div>
        </div>
        <div ref="resource" :style="{order:isShowList['资源阅读'].sort}" class="resource" v-if="isShowList.hasOwnProperty('资源阅读')">
          <div class="resource-list" v-if="resourceModel">
            <van-cell is-link to="resource" class="resource-title" center>
              <template #title>
                <span class="model-title">资源阅读</span>
              </template>
              <template #right-icon>
                <div class="more-parent">
                  <span class="more-val">更多</span>
                </div>
              </template>
            </van-cell>
            <div class="resource-content-list">
              <ul class="list" @scroll="reScroll" ref="relist">
                <li v-for="item in recommendList" @click="goRecommend(item)">
                  <img :src="item.coverPath" alt="">
                  <span class="list-block">
                    <span class="list-overflow">{{ item.title }}</span>
                  </span>
                </li>
              </ul>
            </div>
            <div class="scroll-bar" ref="reScrollBar">
              <div class="bar" ref="reBar"></div>
            </div>
          </div>
          <div class="recommend" v-else>
            <h1 class="recommend-title">资源推荐</h1>
            <div class="recommend-content-list">
              <div class="recommend-content">
                <dl v-for="item in recommendList" @click="goRecommend(item)">
                  <dt><img :src="item.coverPath" alt=""></dt>
                  <dd>
                    <p class="recommend-name">{{ item.title }}</p>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
        <div ref="project" :style="{order:isShowList.hasOwnProperty('专题展览')? isShowList['专题展览'].sort : isShowList['书刊推介'].sort}" class="project" v-if="isShowList.hasOwnProperty('专题展览') || isShowList.hasOwnProperty('书刊推介')">
          <van-cell is-link center>
            <template #title>
              <div class="project-tab-title">
                <span :class="projectColumn===0?'active':''" @click="project" v-if="isShowList.hasOwnProperty('专题展览')">专题展览</span>
                <span :class="projectColumn===1?'active':''" @click="bookRecommend" v-if="isShowList.hasOwnProperty('书刊推介')">书刊推介</span>
              </div>
            </template>
            <template #right-icon>
              <div @click="goMore" class="more-parent">
                <span class="more-val">更多</span>
              </div>
            </template>
          </van-cell>
          <!--专题展览-->
          <ul class="oInformation" v-for="item in specialList" v-if="isProject && isShowList.hasOwnProperty('专题展览')" @click="goProject(item.id,item.title,item.link,item.descHtml)">
            <li class="project-title">{{ item.title }}</li>
            <li class="project-title project-title-right" v-if="item.subTitle">{{ item.subTitle }}</li>
            <li class="project-img">
              <img :src="item.coverPath?baseUrl+item.coverPath:require('@/assets/img/information-img.png')" alt="">
            </li>
          </ul>
          <div class="book-box" v-else>
            <div class="list-box">
              <ul class="book-list" @scroll="scroll" ref="list">
                <li v-for="item in bookRecommendList">
                  <img :src="item.coverPath" alt="">
                  <span> {{ item.title }} </span>
                </li>
              </ul>
            </div>
            <div class="scroll-bar" ref="scrollBar">
              <div class="bar" ref="bar"></div>
            </div>
          </div>
        </div>
        <div ref="guide" :style="{order:isShowList['读者指南'].sort}" class="guide"  v-if="isShowList.hasOwnProperty('读者指南')">
          <div class="guide-left">
            <dl @click="goGuide">
              <dd>
                <p class="guide-title">读者指南</p>
              </dd>
              <dt class="guide-logo">
              </dt>
            </dl>
          </div>
          <div class="guide-right">
            <dl v-for="(item,key) in guideList" @click="go(item.id,item.title)">
              <dt>
                <svg-icon :iconClass='guideIcon[key].icon' className='guide-icon'></svg-icon>
              </dt>
              <dd class="guide-list-title">{{item.title}}</dd>
            </dl>
            <dl @click="goSeek">
              <dt>
                <svg-icon iconClass='guide7' className='guide-icon'></svg-icon>
              </dt>
              <dd class="guide-list-title">智能问答</dd>
            </dl>
            <dl @click="goResearch">
              <dt>
                <svg-icon iconClass='guide5' className='guide-icon'></svg-icon>
              </dt>
              <dd class="guide-list-title">科研参考</dd>
            </dl>
            <dl @click="goMessageBoard">
              <dt>
                <svg-icon iconClass='guide6' className='guide-icon'></svg-icon>
              </dt>
              <dd class="guide-list-title">联系我们</dd>
            </dl>
          </div>
        </div>
        <div ref="cultural" :style="{order:isShowList['文创产品'].sort}" class="cultural" v-if="isShowList.hasOwnProperty('文创产品')">
          <van-cell is-link to="cultural" center>
            <template #title>
              <span class="model-title">国图文创</span>
            </template>
            <template #right-icon>
              <div class="more-parent">
                <span class="more-val">更多</span>
              </div>
            </template>
          </van-cell>
          <div class="cultural-list">
            <dl class="shop" v-for="item in list" @click="goCultural(item.link)">
              <dt class="shop-img"><img :src="baseUrl+item.coverPath" alt=""></dt>
              <dd>{{ item.title }}</dd>
            </dl>
          </div>
        </div>
        <div ref="dynamic" :style="{order:isShowList['动态数据'].sort}" class="dynamic-data" v-if="isShowList.hasOwnProperty('动态数据')">
          <van-cell class="dynamic-title" value="" center>
            <template #title>
              <span class="model-title">动态数据</span>
            </template>
          </van-cell>
          <div class="dynamic-text">
            <ul>
              <li><img src="@/assets/img/dynamic-list.png" alt=""><span class="dynamic-text-num">{{ dataList.userOnline }}</span>网站在线人数</li>
              <li><img src="@/assets/img/dynamic-list.png" alt=""><span class="dynamic-text-num">{{ dataList.userRealName }}</span>实名用户量</li>
              <li><img src="@/assets/img/dynamic-list.png" alt=""><span class="dynamic-text-num">{{ dataList.userCard }}</span>办证量</li>
            </ul>
          </div>
          <div class="dynamic-gif">
            <div class="gif"></div>
          </div>
          <div class="dynamic-ball">
            <div class="dynamic-gif-num">{{ dataList.websiteClick }}</div>
            <div class="dynamic-click-num">网站点击量</div>
          </div>
        </div>
      </div>
    </div>
    <div class="float-box">
      <div class="ctr" @click="showOverlay = true"></div>
      <scroll></scroll>
    </div>
    <van-tabbar v-model="active" class="home-tab" ref="tab">
      <van-tabbar-item to="/">
        <span>首页</span>
        <template #icon="props">
          <span class="tabbar-bg"></span>
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="resource">
        <span>资源</span>
        <template #icon="props">
          <span class="tabbar-bg"></span>
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="information">
        <span>资讯</span>
        <template #icon="props">
          <span class="tabbar-bg"></span>
        </template>
      </van-tabbar-item>
      <van-tabbar-item  to="personal">
        <span>个人中心</span>
        <template #icon="props">
          <span class="tabbar-bg"></span>
        </template>
      </van-tabbar-item>
    </van-tabbar>
    <van-overlay :show="showOverlay">
      <div class="wrapper">
        <div class="block">
          <div class="overlay-close"  @click="showOverlay = false"></div>
          <div class="box overlay-make" @click="goSubscribe">预约<br/>入馆</div>
          <div class="box overlay-message" @click="goMessageBoard">联系<br/>我们</div>
          <div class="box overlay-down" @click="downApp">请您<br/>关注</div>
          <div class="box overlay-guide" @click="goGuide" v-if="isShowList.hasOwnProperty('读者指南')">读者<br/>指南</div>
          <div class="search-code" v-show="codeShow">
            <img src="../../assets/img/subscribe.jpg" alt="" ref="codeImg">
            <div @click="clickSave">长按保存</div>
          </div>
        </div>
      </div>
    </van-overlay>
    <version></version>
<!--    <div class="mask" v-if="isVersion">-->
<!--      <div class="mask-bg"></div>-->
<!--      <div class="mask-dialog">-->
<!--        <img src="../../assets/img/mask-dialog.png" alt="">-->
<!--        <div class="btn">-->
<!--          <div class="mask-new" @click="goNew()">体验新版</div>-->
<!--          <div class="mask-old" @click="goOld()"> 访问旧版</div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import Vue from 'vue'
import navigation from '../../components/navigation'
import { Swipe, SwipeItem, Search, Toast, NoticeBar } from 'vant'
import {request} from '../../untils/request'
import QRCode from 'qrcodejs2' // 引入qrcode
import version from '../../components/version'
import scroll from '../../components/scroll'
import {parseTime} from '../../untils/formatTime'

Vue.use(Swipe).use(SwipeItem).use(Search).use(Toast).use(NoticeBar)

export default {
  name: 'home',
  components: {navigation,version, scroll},
  data () {
    return {
      baseUrl: process.env.API_ROOT,
      active: 0,
      poetry: '',
      todayPlay: true,
      specialList: [],
      list: [],
      bannerList: [],
      informationList: [],
      guideList: [],
      guideIcon: [
        {
          icon: 'guide1'
        },
        {
          icon: 'guide2'
        },
        {
          icon: 'guide3'
        },
        {
          icon: 'guide4'
        },
        {
          icon: 'guide5'
        },
        {
          icon: 'guide6'
        }
      ],
      recommendList: [],
      showAll: false,
      lectureList: [],
      bookRecommendList: [],
      isProject: true,
      projectColumn: 0,
      idData: true,
      showOverlay: false,
      skin: 'a',
      mottoPlay: true,
      audioNodes: [], // 用于存放所有 audio 的 DOM 节点
      audioArr: {
        currentTime: '00:00'
      }, // 用于维护 audio 的总时长和当前播放时间的数组
      dataList: '',
      timer: '',
      codeShow: false,
      isShowList: [],
      isTop: false,
      noticeList: '',
      listSort: [],
      resourceModel: true,
      leaveList:[],
      isVersion: true
    }
  },
  created () {
    // 获取显示模块
    this.getModule()
    let themeLink = document.querySelector('link[name="theme"]');
    // 党建
    // themeLink.setAttribute("href", require('./dj/dj.css'));
    // 原生
    // themeLink.setAttribute("href", require('./original/original.css'));
    // 建军
    // themeLink.setAttribute("href", require('./jianjun/jianjun.css'));
    // 黑白
    // themeLink.setAttribute("href", require('./theme/theme.css'));
    // 中秋
    // themeLink.setAttribute("href", require('./zhongqiu/zhongqiu.css'));
    // 重阳节
    // themeLink.setAttribute("href", require('./chongyang/chongyang.css'));
    // 元旦
    // themeLink.setAttribute("href", require('./yuandan/yuandan.css'));
    // 春节
    // themeLink.setAttribute("href", require('./chunjie/chunjie.css'));
    // 春季
    //themeLink.setAttribute("href", require('./chunji/chunji.css'));
    // 夏季
    // themeLink.setAttribute("href", require('./xiaji/xiaji.css'));
    // 国庆
    // themeLink.setAttribute("href", require('./guoqing/guoqing.css'));
    // 清明
    // themeLink.setAttribute("href", require('./qingming/qingming.css'));
    // 端午
    // themeLink.setAttribute("href", require('./duanwu/duanwu.css'));
    // 教师
    // themeLink.setAttribute("href", require('./jiaoshi/jiaoshi.css'));
    // 儿童
    // themeLink.setAttribute("href", require('./ertong/ertong.css'));
    // 冬季
    //themeLink.setAttribute("href", require('./dongji/dongji.css'));
    // 秋季
    // themeLink.setAttribute("href", require('./qiuji/qiuji.css'));
    this.timer = setInterval(this.getDynamicData, 300000)
    // 重要通知
    this.getNotice()
    // 获取资源推荐模版
    this.getModel ()
    // document.body.style.overflow = 'hidden'
    // if(sessionStorage.getItem("isVersion")){
    //   this.isVersion = false
    //   document.body.style.overflow = 'scroll'
    // } else {
    //   this.isVersion = true
    //   document.body.style.overflow = 'hidden'
    // }
  },
  mounted () {
    this.qrcode()
    window.addEventListener("scroll",this.handScroll)
    this.isIPhoneX()
  },
  methods: {
    // 去新版
    goNew() {
      this.isVersion = false
      sessionStorage.setItem("isVersion", false)
      document.body.style.overflow = 'scroll'
    },
    // 去旧版
    goOld(){
      window.location.href='http://202.106.125.164/client/index.jsp'
      sessionStorage.setItem("isVersion", false)
      document.body.style.overflow = 'scroll'
    },
    // 获取资源推荐模版
    getModel () {
      request('get', '/nlc-web/api/bookRecommend/showStyle').then(res => {
        console.log('资源推荐模版', res)
        if(res.data.dictValue === 'VERTICAL_PLATE'){
          // 竖版
          this.resourceModel = true
        } else {
          // 横版
          this.resourceModel = false
        }
      })
    },
    // 获取显示模块
    getModule () {
      request('get', '/nlc-web/api/control/module').then(res => {
        console.log('显示模块', res)
        let content = res.data.content
        this.listSort = content
        content.forEach(item => {
          if (item.status === 'SUCCESS') {
            this.isShowList[item.name] = {
              status: item.status,
              sort: item.sort
            }
          }
        })
        if(!this.isShowList.hasOwnProperty('专题展览')) {
          this.projectColumn=1
        }
        console.log('isShowList', this.isShowList)
        // 文津
        this.getPoetry()
        // 专题展览
        this.getSpecial()
        // 文创
        this.getCultural()
        // banner
        this.getBanner()
        // 最新资讯
        this.getInformation()
        // 读者指南
        this.getGuide()
        // 资源阅读
        this.getRecommend()
        // 近期预告
        this.getTrailer()
        // 书刊推荐
        this.getBookRecommend()
        // 获取动态数据
        this.getDynamicData()
      })
    },
    // 专题展览显示
    project  () {
      this.isProject = true
      this.projectColumn = 0
    },
    // 书刊推介显示
    bookRecommend  () {
      this.isProject = false
      this.projectColumn = 1
    },
    // 书刊推介
    getBookRecommend () {
      var params = {
        pageNum: '1',
        pageSize: '8'
      }
      request('get', '/nlc-web/api/bookRecommend', params).then(res => {
        console.log('书刊推介', res)
        this.bookRecommendList = res.data.content
      })
    },
    // 专题展览和书刊推荐更多
    goMore () {
      if (this.isProject === true) {
        this.$router.push({name: 'projectList'})
      } else {
        this.$router.push({name: 'bookRecommend'})
      }
    },
    // 近期预告
    getTrailer () {
      let params = {
        pageNum: '1',
        pageSize: '5'
      }
      request('get', '/nlc-web/api/nlcNotice/page', params).then(res => {
        console.log('近期预告', res)
        this.lectureList = res.data.content
      })
    },
    // 资源阅读
    getRecommend () {
      let params = {
        type: 'HOT'
      }
      request('get', '/nlc-web/api/resourceRead/recommend', params).then(res => {
        console.log('资源阅读', res)
        res.data.content.forEach(item=>{
          if(item.coverPath.substr(0,7).toLowerCase() === "http://" || item.coverPath.substr(0,8).toLowerCase() === "https://"){
            item.coverPath = item.coverPath;
          }else{
            item.coverPath = this.baseUrl + item.coverPath;
          }
        })
        this.recommendList = res.data.content
      })
    },
    // banner跳转
    goBanner  (e) {
      let newStr = e.link.indexOf('http')
      if (newStr === 0) {
        // window.location.href = link
        window.open(e.link)
      } else {
        var src = process.env.API_ROOT + e.link
        // window.location.href = src
        window.open(src)
      }
    },
    // 资源阅读跳转
    goRecommend (e) {
      let params = {
        resId: e.id,
        resName: e.title,
        moduleName: '资源阅读'
      }
      request('post', '/nlc-web/api/websiteData/res',params).then(res => {
        console.log('统计',res)
      })
      let newStr = e.link.indexOf('http')
      if (newStr === 0) {
        // window.location.href = link
        window.open(e.link)
      } else {
        var src = process.env.API_ROOT + e.link
        // window.location.href = src
        window.open(src)
      }
    },
    // 文津
    getPoetry () {
      let date = new Date()
      let year = date.getFullYear() // 年
      let month = (date.getMonth() + 1).toString().padStart(2, 0) // 月
      let day = date.getDate().toString().padStart(2, 0) // 日
      let nowDate = `${year}-${month}-${day}`
      let releaseDate = {
        releaseDate: nowDate
      }
      request('post', '/nlc-web/api/poetryRead/date', releaseDate).then(res => {
        console.log('文津经典诵读', res)
        this.poetry = res.data
      })
    },
    // 专题展览
    getSpecial () {
      let params = {
        pageNum: '1',
        pageSize: '1'
      }
      request('get', '/nlc-web/api/special', params).then(res => {
        console.log('专题展览', res)
        this.specialList = res.data.content
      })
    },
    // 专题展览详情
    goProject (id,title,link,descHtml) {
      if (link) {
        let params = {
          resId: id,
          resName: title,
          moduleName: '专题'
        }
        request('post', '/nlc-web/api/websiteData/res',params).then(res => {
          console.log('统计',res)
        })
        // window.location.href = link
        window.open(link)
      } else {
        if(!descHtml){
          this.getDirectory (id)
        } else {
          this.$router.push({name: 'articleDetails', params: {id: id}})
        }
      }
    },
    getDirectory (id) {
      request('get', '/nlc-web/api/special/cataloguesAll', {}, id).then(res => {
        console.log('目录列表', res)
        this.getLeave(res.data)
        this.$router.push({name: 'articleChildDetails', query: {id: this.leaveList[0], parentId:id}})
      })
    },
    // 查找子目录第一层级
    getLeave(data){
      if(data.length>0){
        this.getLeave(data[0].subsetList)
        this.leaveList.push(data[0].id)
      }
    },
    // 文创
    getCultural () {
      let params = {
        pageNum: '1',
        pageSize: '3'
      }
      request('get', '/nlc-web/api/cultural', params).then(res => {
        console.log('文创列表', res)
        this.list = res.data.content
      })
    },
    // banner
    getBanner () {
      let params = {
        pageNum: '1',
        pageSize: '5'
      }
      request('get', '/nlc-web/api/banner', params).then(res => {
        console.log('banner', res)
        this.bannerList = res.data
      })
    },
    // 去读者指南
    goGuide () {
      this.$router.push({name: 'guide'})
    },
    // 搜索
    onSearch () {
      this.$router.push({name: 'search'})
    },
    // 最新资讯
    getInformation () {
      request('get', '/nlc-web/api/information/indexList', {}).then(res => {
        console.log('最新资讯', res)
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].informationType === 'INFORMATION_SOLICITATION') {
            res.data[i].informationType = '征集'
          } else if (res.data[i].informationType === 'INFORMATION_NEWS') {
            res.data[i].informationType = '新闻'
          } else {
            res.data[i].informationType = '公告'
          }
          res.data[i].startTime = parseTime(res.data[i].startTime,'{y}-{m}-{d}')
        }
        this.informationList = res.data
      })
    },
    // 最新资讯查看更多
    goInformation () {
      this.$router.push({name: 'information'})
    },
    // 去最新资讯详情
    goDetail (id, type) {
      var title = ''
      if (type === '公告') {
        title = '最新公告'
      } else if (type === '新闻') {
        title = '国图新闻'
      } else {
        title = '征集启事'
      }
      this.$router.push({name: 'newsDetail', query: {id: id}})
    },
    // 读者指南
    getGuide () {
      let params = {
        pageNum: '1',
        pageSize: '4'
      }
      request('get', '/nlc-web/api/readerGuide', params).then(res => {
        console.log('读者指南列表', res)
        res.data.content.pop()
        this.guideList = res.data.content
        console.log('this.guideList', this.guideList)
      })
    },
    // 预约入馆
    goSubscribe  () {
      if(this.codeShow){
        this.codeShow = false
      } else {
        this.codeShow = true
      }
    },
    // 长按保存
    clickSave () {
      let alink = document.createElement("a");
      alink.href = this.shopImg
      alink.download = this.baseUrl + this.$refs.codeImg.src; //图片名
      alink.click();
    },
    // 联系我们
    goMessageBoard  () {
      this.$router.push({path: `/messageBoard`})
    },
    // 咨询台
    goSeek(){
      window.location.href = 'https://ianswer.yilinkin.com/'
    },
    // 科研参考
    goResearch () {
      window.location.href = 'http://ir.nlc.cn/library/guest/technology'
    },
    // 读者指南去详情
    go (id, title) {
      var params = {
        readerGuideId: id
      }
      request('post', '/nlc-web/api/readerGuide/info', params).then(res => {
        console.log('目录', res)
        if (res.data.childNode.length !== 0) {
          this.$router.push(
              {
                path: `/guideDirectory`,
                query: {
                  id: id,
                  title: '指南目录'
                }
              }
          )
        } else {
          this.$router.push(
              {
                path: `/openTime`,
                query: {
                  id: id,
                  title: title
                }
              }
          )
        }
      })
    },
    // 距顶部距离
    handScroll () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      let scrollHeight = document.body.clientWidth
      if (scrollTop>scrollHeight){
        this.isTop = true
      } else {
        this.isTop = false
      }
    },
    // 返回顶部
    toTop () {
      let top = document.documentElement.scrollTop || document.body.scrollTop
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50
        if (top <= 0) {
          this.isTop = false
          clearInterval(timeTop)
        }
      }, 10)
    },
    // 下载app
    downApp () {
      this.$router.push({
        name: 'application'
      })
    },
    // 播放
    play () {
      if (this.$refs.motto && !this.$refs.motto.paused) {
        this.$refs.motto.pause()
        this.mottoPlay = true
      }
      this.todayPlay = false
      this.$refs.todayAudio.play()
    },
    // 暂停
    pause () {
      this.todayPlay = true
      this.$refs.todayAudio.pause()
    },
    // 美德格言音频播放
    mottoAudio () {
      if (this.mottoPlay === true) {
        if (!this.$refs.todayAudio.paused) {
          this.$refs.todayAudio.pause()
          this.todayPlay = true
        }
        this.mottoPlay = false
        this.$refs.motto.play()
      } else {
        this.mottoPlay = true
        this.$refs.motto.pause()
      }
    },
    // 获取音频的总时长
    fillTime (event) {
      console.log('event.target.duration', event.target.duration)
      this.audioArr.duration = this.transTime(event.target.duration)
    },

    // 将秒数转化成(分:秒)格式
    transTime (time) {
      let duration = parseInt(time)
      let minute = parseInt(duration / 60).toString().padStart(2, '0')
      let sec = (duration % 60).toString().padStart(2, '0')
      return `${minute}:${sec}`
    },

    // 进度条播放的事件
    updateProgress () {
      let audio = this.$refs.motto
      let value = Math.round((Math.floor(audio.currentTime) / Math.floor(audio.duration)) * 100, 0)
      this.audioArr.currentTime = this.transTime(audio.currentTime)
      let progressTag = document.getElementsByClassName('timeBar')[0]
      progressTag.style.width = `${value}%`
    },

    // 播放结束的处理动作
    audioEnded () {
      let audio = this.$refs.motto
      audio.currentTime = 0
      audio.pause()
      this.mottoPlay = true
    },
    // 单位换算
    formatNumber (value) {
      const newValue = ['', '', '']
      let fm = 1
      let num = 3
      let text1 = ''
      let fr = 1000
      while (value / fr >= 1) {
        fr *= 10
        num += 1
        // console.log('数字', value / fr, 'num:', num)
      }
      if (num <= 4) { // 千
        newValue[0] = value + ''
        // newValue[1] = '千'
      } else if (num <= 8) { // 万
        text1 = parseInt(num - 4) / 3 > 1 ? '万' : '万'
        // tslint:disable-next-line:no-shadowed-variable
        fm = text1 === '万' ? 10000 : 10000000
        // if (value % fm === 0) {
        //   newValue[0] = parseInt(value / fm) + ''
        // } else {
        //   newValue[0] = parseFloat(value / fm).toFixed(2) + ''
        // }
        newValue[0] = parseInt(value / fm) + ''
        newValue[1] = text1
      } else if (num <= 16) { // 亿
        text1 = (num - 8) / 3 > 1 ? '千亿' : '亿'
        text1 = (num - 8) / 4 > 1 ? '万亿' : text1
        text1 = (num - 8) / 7 > 1 ? '千万亿' : text1
        // tslint:disable-next-line:no-shadowed-variable
        fm = 1
        if (text1 === '亿') {
          fm = 100000000
        } else if (text1 === '千亿') {
          fm = 100000000000
        } else if (text1 === '万亿') {
          fm = 1000000000000
        } else if (text1 === '千万亿') {
          fm = 1000000000000000
        }
        if (value % fm === 0) {
          newValue[0] = parseInt(value / fm) + ''
        } else {
          newValue[0] = parseFloat(value / fm).toFixed(2) + ''
        }
        newValue[1] = text1
      }
      if (value < 1000) {
        newValue[0] = value + ''
        newValue[1] = ''
      }
      return newValue.join('');
    },
    // 获取动态数据
    getDynamicData () {
      request('get', '/nlc-web/api/dynamicData').then(res => {
        console.log('动态数据', res)
        if (res.data.websiteClick) {
          res.data.websiteClick = this.formatNumber(res.data.websiteClick)
        }
        if (res.data.userRealName) {
          res.data.userRealName = this.formatNumber(res.data.userRealName)
        }
        if (res.data.userCard) {
          res.data.userCard = this.formatNumber(res.data.userCard)
        }
        this.dataList = res.data
      })
    },
    // 获取重要通知
    getNotice () {
      this.noticeList = []
      request('get', '/nlc-web/api/information/indexShow').then(res => {
        console.log('重要通知', res)
        if (res.code===200) {
          if(res.data[0]){
            if (res.data[0].informationType === 'INFORMATION_SOLICITATION') {
              res.data[0].informationType = '征集'
            } else if (res.data[0].informationType === 'INFORMATION_NEWS') {
              res.data[0].informationType = '新闻'
            } else {
              res.data[0].informationType = '公告'
            }
          }
          this.noticeList = res.data[0]
        }
      })
    },
    // 分享到微博
    shareWb () {
      let param = {
        url: location.href,
        appkey: '1343713053', /** 您申请的应用appkey,显示分享来源(可选)*/
        title: document.title, /** 分享的文字内容(可选，默认为所在页面的title)*/
      }
      let temp = [];
      for( let p in param ){
        temp.push(p + '=' + encodeURIComponent( param[p] || '' ) )
      }
      let target_url = "http://service.weibo.com/share/share.php?"+temp.join('&');
      window.open(target_url, 'sinaweibo')
    },
    qrcode () {
      new QRCode('qrcodeImg', {
        width: 100,
        height: 100,
        text: location.href, // 二维码地址
        colorDark: '#000',
        colorLight: '#fff'
      })
    },
    // 分享微信
    goWechat () {
      if (this.codeShow === true) {
        this.codeShow = false
      } else {
        this.codeShow = true
      }
    },
    // 去文创详情页
    goCultural (link) {
      // this.$router.push({name: 'culturalDetail',query:{id: id}})
      window.location.href = link
    },
    // 获取滚动条距离书刊推介
    scroll  (event) {
      let barSCrollWidth = this.$refs.scrollBar.clientWidth - this.$refs.bar.clientWidth // 自定义滑条可移动范围
      let left = event.target.scrollLeft * barSCrollWidth / this.$refs.list.scrollWidth/2
      if(left > 86){
        this.$refs.bar.style.marginLeft = `${86}%`
      } else if(left < 0){
        this.$refs.bar.style.marginLeft = `${0}%`
      } else {
        this.$refs.bar.style.marginLeft = `${left}%`
      }
    },
    // 获取滚动条距离资源阅读
    reScroll  (event) {
      let barSCrollWidth = this.$refs.reScrollBar.clientWidth + this.$refs.reBar.clientWidth // 自定义滑条可移动范围
      let left = event.target.scrollLeft * barSCrollWidth / event.target.scrollWidth
      if(left > 86){
        this.$refs.reBar.style.marginLeft = `${86}%`
      } else if(left < 0){
        this.$refs.reBar.style.marginLeft = `${0}%`
      } else {
        this.$refs.reBar.style.marginLeft = `${left}%`
      }
    },
    // 判断手机是否为iphonex
    isIPhoneX() {
      let u = navigator.userAgent;
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isIOS) {
        if (screen.height >= 812) {
          //是iphoneX
          console.log('this.$refs.tab.style',this.$refs.tab)
          this.$refs.tab.$el.style.paddingBottom = `${.2}rem`
        }
      }
    }
  }
}
</script>

<style scoped>
.app-container{
  background:#ECF5FD;
  padding-bottom:1.3rem;
  overflow-y:scroll;
  position:relative;
}
.model-flex{
  display:flex;
  flex-flow: column;
}
>>>.overlay-wx .social-share .icon-wechat{
  border:none;
  margin: -.01rem 0 0 .06rem;
  color:#008095;
}
>>>.overlay-wb .social-share .icon-weibo{
  border:none;
  margin: -.01rem 0 0 0;
  color:#008095;
}
>>>.overlay-wx .social-share .icon-wechat:hover{
  background:none;
}
>>>.overlay-wb .social-share .icon-weibo:hover{
  background:none;
}
#qrcodeImg{
  width:2rem;
  height:2rem;
  margin: 0 auto;
}
.search-code{
  position: absolute;
  left: .1rem;
  top: -3.2rem;
  z-index:999;
  width:2.2rem;
  height:2.8rem;
  border-radius:16px;
  background:#fff;
  font-size:.2rem;
  text-align:center;
}
.search-code img{
  width:2.2rem;
  height:2.2rem;
  border-radius:16px;
}
.triangle_border_down{
  width:0;
  height:0;
  border-width:20px 20px 0;
  border-style:solid;
  border-color:#fff transparent transparent;/*灰 透明 透明 */
  position:absolute;
  bottom:-.2rem;
  left:.95rem;
}
.float-box{
  position:fixed;
  bottom:1.6rem;
  right:.3rem;
  width:.97rem;
  height:1.94rem;
}
.ctr{
  width:1.18rem;
  height:1.18rem;
  background-size:100%;
}
.return-top{
  width:1.18rem;
  height:1.18rem;
  background-size:100%;
  margin-top:-.3rem;
}
.wrapper {
  position:absolute;
  bottom: 1.32rem;
  right: 0.28rem;
}
.block {
  width: 2.3rem;
  height: 3.16rem;
  background:url(../../assets/img/arc.png) no-repeat 0 -.08rem;
  background-size:100%;
  position:relative;
  font-size:.2rem;
  color:#008095;
}
.overlay-close{
  width:1.18rem;
  height:1.18rem;
  background-size:100%;
  position:absolute;
  right: -.2rem;
  bottom: 1.05rem;
}
.box{
  width:.58rem;
  height:.58rem;
  border-radius:50%;
  text-align:center;
  line-height: .3rem;
  color:#fff;
  padding:.08rem;
}
.box img{
  width:.4rem;
  height:.4rem;
  padding-top:.1rem;
}
.overlay-down{
  position:absolute;
  right: 1.75rem;
  top: 1.7rem;
}
.overlay-guide{
  position:absolute;
  right: .5rem;
  top: 2.45rem;
}
.overlay-make {
  position:absolute;
  right: .5rem;
  top: -.4rem;
}
.overlay-message{
  position:absolute;
  right: 1.75rem;
  top: .4rem;
}
.overlay-wx{
  position:absolute;
  right: 1.85rem;
  top: 0.75rem;
}
.overlay-wx span {
  background:url(../../assets/img/overlay-wx.png) no-repeat;
}
.overlay-wb span {
  background:url(../../assets/img/overlay-wb.png) no-repeat;
}
.overlay-wx span,.overlay-wb span{
  width:.4rem;
  height:.4rem;
  display:inline-block;
  background-size: 100%;
  margin-top: .08rem;
}
.overlay-wb{
  position:absolute;
  right: 1.8rem;
  top: 1.8rem;
}
.main{
  width:6.94rem;
  margin:1.05rem .28rem 0 .28rem;
}
.banner{
  position:relative;
  margin-bottom:.55rem;
}
.banner-img{
  width:100%;
  height:100%;
}
.van-search{
  width:6.4rem;
  height:.8rem;
  border-radius:40px;
  position:absolute;
  bottom:-.4rem;
  left:.27rem;
  vertical-align: middle;
}
.van-search__content{
  background:#fff;
}
.my-swipe{
  width:100%;
  height:3.6rem;
  border-radius:8px;
  -webkit-transform:rotate(0deg);
}
.van-swipe >>>.van-swipe__indicators{
  bottom:26px !important;
}
.more{
  width:.13rem;
  height:.24rem;
  vertical-align: middle;
}
.detail-scroll{
  width:3.7rem;
  height:.4rem;
  overflow:hidden;
}
.details{
  font-size:.28rem;
  font-family: SourceHanSerifCN-Regular;
  width:auto;
  height:.55rem;
  white-space: nowrap;
}
.model-title{
  font-weight:bold;
  font-family: SourceHanSerifCN-SemiBold;
}
.trailer-box{
  height:.5rem;
  display:flex;
  line-height:.05rem;
  margin-bottom:.1rem;
}
.trailer-content{
  height:2.62rem;
  border-radius:8px;
  display:flex;
  background-size:100%;
  vertical-align: middle;
  /*margin-top:.16rem;*/
}
.trailer-cell{
  padding:.19rem .3rem .19rem .1rem;
  height:1.31rem;
}
.trailer-cell .van-cell__label{
  line-height:30px;
  margin-top:1px;
  font-size:.2rem;
}
.trailer-cell::after{
  border-bottom: 1px solid #B3BBC3 !important;
}
.trailer-title-bg{
  background:none !important;
  padding:0 .2rem .1rem .1rem !important;
}
.custom-more{
  width:.13rem;
  height:.24rem;
  display:inline-block;
  background-size:100%;
  margin:.13rem 0 0 .15rem;
}
.title-trailer {
  display:flex;
  line-height:.55rem;
}
.title-trailer span{
  margin-right:.1rem;
}
.trailer-sides{
  display: flex;
  align-items: center;
  margin:0 .1rem;
}
.custom-bar{
  width:.02rem;
  height:.25rem;
  display:inline-block;
  background: #CDD5DD;
  margin:.03rem 0 0 .06rem;
}
.danger{
  display:inline-block;
  height:.24rem;
  line-height:.24rem;
  background:#CB0A0A;
  border-radius:2px;
  font-size:.14rem;
  color:#fff;
  padding:.02rem .05rem;
  margin-top:.13rem;
}
.trailer-title{
  width:.66rem;
  height:.76rem;
  line-height:.38rem;
  display:inline-block;
  font-size:.32rem;
  font-family: SourceHanSerifCN-SemiBold;
  vertical-align: middle;
  margin-left: .2rem;
  font-weight:bold;
}
.trailer-more{
  font-size:.22rem;
  width:.2rem;
  height:1.16rem;
  line-height:.29rem;
  display: inline-block;
  margin-right:.37rem;
  font-family: SourceHanSerifCN-Regular;
  position: absolute;
  right: .37rem;
}
.cell-title{
  width:4.76rem;
  height:.45rem;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.trailer-icon{
  width:.24rem;
  height:.2rem;
  display:inline-block;
  background-size:100%;
}
.trailer-list-title{
  font-size:.3rem;
  font-family: SourceHanSerifCN-SemiBold;
}
.cell-label{
  color:#CB0A0A;
}
.guide{
  margin-top:.16rem;
  background:#fff;
  width:6.94rem;
  height:2.95rem;
  border-radius:8px;
  display:flex;
  padding:.25rem 0;
  font-size:.28rem;
  font-family: SourceHanSerifCN-SemiBold;
}
.guide-left{
  width:1.7rem;
  height:2.95rem;
  border-right:1px solid #DCE5ED;
  font-size:.34rem;
  margin:0 0 0 .26rem;
  padding-right:.14rem;
}
.guide-left dl{
  width:100%;
  margin:0;
}
.guide-left dl dd{
  width:100%;
  margin:.19rem 0 0 0;
  vertical-align: bottom;
}
.guide-title{
  height:.89rem;
  margin:0;
  padding-top:.53rem;
}
.guide-logo{
  width:1.16rem;
  height:1.07rem;
  margin:0 0 0 .14rem;
  background-size:100%;
}
.guide-right{
  width:5rem;
}
.guide-right dt{
  font-size:.44rem;
  text-align:center;
}
.guide-right dl{
  width:1.6rem;
  height:.94rem;
  float:left;
  text-align:center;
  margin:0;
  padding:.25rem 0;
  border-right:1px solid #DCE5ED;
  border-bottom:1px solid #DCE5ED;
}
.guide-right dl:nth-child(4),.guide-right dl:nth-child(5),.guide-right dl:nth-child(6){
  border-bottom:none;
}
.guide-right dl:nth-child(3),.guide-right dl:nth-child(6){
  border-right:none;
}
.guide-right dl dd{
  width:100%;
  margin:.1rem 0 0 0;
}
.guide-list-logo{
  font-size:.44rem;
}
.van-cell--clickable{
  padding-top:.25rem;
  border-radius: 16px;
}
.van-cell--clickable::after{
  border:0 !important;
}
.poetryRead{
  width:100%;
  background:#fff;
  margin-top:.16rem;
  border-radius:8px;
  padding-bottom:.3rem;
}
.van-cell__value{
  color:#008095;
}
.poetryRead-content{
  width:6.35rem;
  height:3rem;
  background-size:100%;
  margin-left:.29rem;
}
>>>.van-tabs__nav{
  background:none
}
>>>.van-tabs--line .van-tabs__wrap{
  height:.55rem;
}
.today{
  display:flex;
  position:relative;
}
.today-left{
  width:2.05rem;
  font-size:.2rem;
  margin-top:.5rem;
  text-align:center;
  color:#fff;
  font-family:SourceHanSerifCN-Light;
}
.today-left p{
  margin:0;
}
.date-today{
  width:.71rem;
  line-height:.48rem;
  font-size:.4rem;
  font-weight: bold;
  color:#fff;
  border-top:1px solid #fff;
  border-bottom:1px solid #fff;
  margin:0 .7rem !important;
  font-family:SourceHanSansCN-Heavy;
}
.weekday{
  font-size:.24rem;
  font-family: SourceHanSerifCN-Medium;
}
.calendar{
  font-family: SourceHanSerifCN-Regular;
}
.today-right{
  position:absolute;
  top:.8rem;
  right:.2rem;
  width:3.7rem;
}
.today-right p{
  margin-bottom:0;
}
.source{
  font-size:.24rem;
  color:#9299A3;
  text-align:right;
  font-family: SourceHanSerifCN-Regular;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.today-audio{
  position: absolute;
  left: 1.8rem;
  top:1.2rem;
}
.today-audio .play{
  margin:0;
  width: .5rem;
  height: .5rem;
  background-size:100%;
  border-radius:50%;
}
.today-audio .pause{
  margin:0;
  width: .5rem;
  height: .5rem;
  background-size:100%;
  border-radius:50%;
}
.translation{
  width:5.99rem;
  overflow:hidden;
  background:#E2F0F3;
  color:#94979C;
  font-size:.24rem;
  margin:.25rem 0 0 0;
  padding:.16rem .18rem;
}
.motto-translation{
  position:relative;
  width:5.5rem;
  line-height:.36rem;
  font-size:.22rem;
  margin:.55rem .26rem 0 0;
  padding:.07rem .21rem .1rem .64rem;
  background:#E2F0F3;
  border-radius:4px;
}
.home-translation{
  display:flex;
  font-family: SourceHanSerifCN-Light;
}
.home-translation img{
  width:.26rem;
  height:.27rem;
  margin-top:.05rem;
}
.home-translation span {
  margin-left: .14rem;
}
.resource{
  width:100%;
  background:#fff;
  border-radius:8px;
  margin-top:.16rem;
  padding-bottom:.2rem;
}
.resource-list{
  background-size:100%;
}
.resource-title{
  background:none;
}
.resource-content-list{
  width:6.44rem;
  height:3.9rem;
  overflow:hidden;
  margin:0 .25rem;
}
.list{
  margin:.15rem 0 0 0;
  padding-bottom:.3rem;
  display:flex;
  font-size:.3rem;
  color:#444649;
  overflow-x:scroll;
  font-family: SourceHanSerifCN-Regular;
}
.list li{
  width:1.8rem;
  margin:0 .2rem;
  text-align:center;
}
.list li:first-child{
  margin-left:0;
}
.list li:last-child{
  margin-right:0;
}
.list li img{
  width:2rem;
  height:2.66rem;
  box-shadow: 6px 4px 10px -6px #00000080;
  margin-bottom:.11rem;
}
.list li .list-block{
  width:1.8rem;
  display:block;
}
.list li .list-overflow{
  width:1.8rem;
  margin-left: .1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.recommend{
  width:6.34rem;
  margin:0 .28rem;
  background:#fff;
  border-radius:8px;
}
.recommend-title{
  font-size:.36rem;
  color:#444649;
  padding-top:.25rem;
  font-family: SourceHanSerifCN-SemiBold;
  margin:0;
}
.recommend-content-list{
  overflow:hidden;
  height:3rem;
  margin-top:.25rem;
}
.recommend-content{
  height:3.4rem;
  overflow-y:scroll;
  display: flex;
}
.recommend-content dl{
  width:2.28rem;
  height:3.2rem;
  margin:0;
  display: block;
  margin:0 .24rem 0 0;
}
.recommend-content dt img{
  width:2.28rem;
  height:1.88rem;
  box-shadow: 6px 4px 10px -6px #000;
}
.recommend-content dd{
  margin:0;
}
.recommend-name{
  margin:0;
  font-size:.28rem;
  font-family: SourceHanSerifCN-Regular;
  color: #444649;
  text-align:center;
  width:2.28rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.project-title{
  font-size:.3rem;
  line-height:.42rem;
  font-family: SourceHanSerifCN-Regular;
  color: #333333;
  padding-left: .12rem;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.project-img{
  width:6.43rem;
  height:2.84rem;
  margin-top:.16rem;
  background:url('../../assets/img/shadow.png') no-repeat;
  background-size:100% 100%;
}
.project-img img{
  width:6.29rem;
  height:2.6rem;
  margin-left:.09rem;
  border-radius:8px;
}
.date{
  color:#94979C;
  font-size:.2rem;
  padding:.1rem 0 .15rem 0;
}
.resource-guide{
  width:100%;
  display:flex;
  font-size:.24rem;
  color:#333;
  text-align:center;
}
.resource-guide dl{
  width:1.73rem;
}
.resource-guide-logo{
  width:.6rem !important;
  height:.6rem !important;
}
.resource-guide dd{
  margin:.15rem 0 0 0;
}
.oInformation{
  border-bottom:1px solid #DCE5ED;
  width:6.43rem;
  margin:.01rem .23rem 0 .23rem;
  padding-bottom:.15rem;
}
.oInformation:last-child{
  border:none !important;
}
.project{
  margin-top:.16rem;
  background:#fff;
  border-radius:8px;
  width:100%;
}
.van-cell__title{
  font-size:.36rem;
  color:#444649;
}
.project-tab-title{
  font-size:.32rem;
  color:#444649;
  font-family: SourceHanSerifCN-SemiBold;
}
.project-tab-title span:nth-child(1){
  margin-right:.64rem;
}
>>>.van-tab--active .van-tab__text--ellipsis{
  font-size:.32rem;
  line-height: .32rem;
  font-weight:normal;
}
>>>.van-tab__text--ellipsis{
  font-size:.28rem;
  line-height: .32rem;
  font-family: SourceHanSerifCN-Regular
}
.active{
  font-size:.36rem;
  font-weight:bold;
}
.serach input{
  font-family: SourceHanSansCN-Normal;
}
.custom-title{
  font-size:.28rem;
  font-weight: 800;
  margin-left:.25rem;
  color:#444649;
  font-family: SourceHanSerifCN-Heavy;
}
.custom-title-little{
  font-size:.28rem;
  width: 3.83rem;
  display: inline-block;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  font-family: SourceHanSerifCN-Regular;
}
.shop{
  width:1.96rem;
  color:#333;
  font-size:.3rem;
  text-align:center;
  margin: .12rem 0 0 .28rem;
  padding-bottom: .3rem;
}
.shop-img img{
  width:1.96rem;
  height:1.96rem;
  border-radius:8px;
}
.shop dd{
  margin:0;
  padding-top:.11rem;
  color:#333;
  width:2rem;
  font-family: SourceHanSerifCN-Regular;
}
.cultural{
  width:100%;
  background:#fff;
  margin-top:.16rem;
  border-radius:8px;
  /*padding-bottom: .24rem;*/
}
.cultural-list{
  display:flex;
}
.more-parent{
  line-height: .24rem;
}
.more-val{
  width:.66rem;
  display:inline-block;
  font-size:.24rem;
  font-family: SourceHanSerifCN-Regular;
  line-height: .24rem;
  vertical-align: middle;
}
.motto-audio{
  width:90%;
  margin:.35rem 0 0 5%;
}
.motto-detail{
  margin:0 .25rem;
  font-size:.28rem;
  color:#333;
}
.from{
  font-size:.24rem;
  text-align:right;
  font-family: SourceHanSerifSC-Light;
}
.book-list{
  padding:.25rem 0 0 0;
  display:flex;
  font-size:.28rem;
  color:#444649;
  font-family: SourceHanSerifCN-Regular;
  overflow-x:scroll;
}
.book-list li{
  width:2rem;
  height:4.1rem;
  flex:1;
  margin:0 .25rem;
  text-align:center;
}
.book-list li:first-child{
  margin-left:0;
}
.book-list li:last-child{
  margin-right:0;
}
.book-list li img{
  width:1.7rem;
  height:2.4rem;
  box-shadow: 6px 4px 10px -6px #000;
  margin-bottom:.11rem;
}
.book-list li span{
  display:block;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.book-box{
  padding-bottom:.32rem;
}
.list-box {
  width:6.3rem;
  height:3.7rem;
  overflow:hidden;
  margin:0 .32rem;
}
.scroll-bar {
  width:6.2rem;
  height:.08rem;
  background: #E6EFF7;
  border-radius: 8px;
  margin-left:.37rem;
  margin-top:.1rem;
}
.bar{
  width:.88rem;
  height:.08rem;
  border-radius: 8px;
}
audio{
  width:100%;
}
>>>.van-swipe-item{
  border-radius:8px;
}
.dynamic-data{
  width: 100%;
  height: 5.08rem;
  background: #fff url(../../assets/img/dynamic-bg.png) no-repeat 0 .64rem;
  background-size:100%;
  margin-top: .16rem;
  border-radius: 8px;
  position:relative;
}
.dynamic-gif{
  position:absolute;
  bottom:0;
  width:6.94rem;
  height:1.72rem;
}
.gif{
  width:100%;
  height:100%;
  background: url(../../assets/img/dynamic.gif) no-repeat;
  background-size:101%;
  border-radius:0 0 8px 8px;
  opacity:.5;
}
.dynamic-gif-num{
  color:#008095;
  font-size:.36rem;
  margin-top:1rem;
  text-align:center;
  font-family: SourceHanSerifCN-SemiBold;
}
.dynamic-click-num{
  position:absolute;
  bottom:-.35rem;
  left:.45rem;
  font-size:.3rem;
  color:#008095;
  text-align:center;
  font-family: SourceHanSerifCN-SemiBold;
}
.dynamic-ball{
  width:2.56rem;
  height:2.56rem;
  background: url(../../assets/img/ball.gif) no-repeat;
  background-size: 100%;
  position: absolute;
  right: .17rem;
  bottom: 1.12rem;
}
.motto-audio{
  width:85%;
  height:.76rem;
  margin-left:5%;
  background: #f2f5f6;
  box-shadow: 0px 51px 128px -38px rgba(0, 0, 0, 0.1);
  padding:.14rem .16rem;
  display:flex;
}
.motto-audio audio {
  height:0;
}
.motto-left{
  padding-top:.15rem;
}
.motto-btn{
  width:.48rem;
  height:.48rem;
  margin:0;
  background: rgba(0, 128, 149, 0.5);
  border-radius:50%;
  position:relative;
}
.motto-btn img{
  position: absolute;
  left: .16rem;
  top: .15rem;
  width: .2rem;
  height: .2rem;
}
.motto-right{
  margin-left:.2rem;
}
.motto-title{
  font-size:.24rem;
  color:#333;
  margin:0;
  padding-bottom:.05rem;
}
.progress-strip{
  width:5.1rem;
}
.progressBar {
  position: relative;
  width: 100%;
  height:.06rem;
  background: #fff;
  border-radius:6px;
}
.timeBar {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background-color: #0B83A1;
  border-radius:6px;
}
.time{
  font-size:.2rem;
  color:#333;
  position:relative;
  margin-top:.05rem;
}
.time-start{
  position: absolute;
  left:0;
}
.time-end{
  position: absolute;
  right:0;
}
.dynamic-title{
  background:none !important;
  padding-top:.2rem;
}
.trailer-content .van-cell{
  background:none;
}
.van-cell::after{
  border:none;
}
.dynamic-text{
  position:absolute;
  left:.33rem;
  top:1.7rem;
  color:#47494c;
  font-size:.2rem;
  line-height:.7rem;
  z-index:1;
  font-family: SourceHanSerifCN-Regular;
}
.dynamic-text li {
  position:relative;
  font-size:.3rem;
  color:#007F95;
}
.dynamic-text li img{
  width:.26rem;
  height:.26rem;
  vertical-align: middle;
}
.dynamic-text-num{
  color:#444649;
  margin-left:.1rem;
  margin-right:.2rem;
  font-size: .28rem;
  font-family: SourceHanSansCN-Medium;
  width:1rem;
  display:inline-block;
}
>>>.van-tabbar-item__icon img{
  width:.56rem;
  height:.56rem;
}
>>>.van-tabbar-item__text{
  font-size:.2rem;
  font-family: SourceHanSerifCN-Medium;
}
>>>.van-tabbar{
  height:1.1rem;
}
>>>.detail-scroll .van-notice-bar{
  height:.4rem;
  color:#444649;
  background:none;
  padding:0;
  font-size:.3rem;
  font-family: SourceHanSerifCN-Regular;
}
.van-notice-bar{
  padding:0 11px;
}
.notice{
  height:.4rem;
  margin-bottom: .1rem;
  background:none;
  font-family: SourceHanSerifCN-Regular;
}
.notice-icon{
  font-size:.28rem;
  padding-right:.1rem !important;
}
.notice >>>.van-notice-bar__content{
  font-size:.28rem;
  line-height:.28rem;
}
.guide-icon{
  padding-right:0;
}
.news{
  width:.45rem;
  height:.25rem;
  margin-top: .13rem;
  margin-right: .1rem;
}
.tabbar-bg{
  width:.56rem;
  height:.56rem;
  display:inline-block;
}
>>>.van-field__control{
  font-size:.28rem;
  line-height:.42rem;
  font-family: SourceHanSerifCN-Regular;
}
>>>.van-icon-search{
  font-size:.32rem !important;
}
.year-author{
  margin:0;
  padding-right:.12rem;
  font-size: .24rem;
  color: #9299A3;
  text-align: right;
}
.project-title-right{
  text-align:right;
}
.mask{
  width: 100%;
  height: 100%;
  position:fixed;
  top:0;
  left:0;
  z-index:99999;
}
.mask-bg{
  width: 100%;
  height: 100%;
  background:rgba(0, 18, 21, 0.6);
}
.mask-dialog{
  width:5.98rem;
  height:5.44rem;
  border-radius: 0.16rem;
  background:#fff;
  position:absolute;
  left:50%;
  top:50%;
  margin-left:-2.99rem;
  margin-top:-2.72rem;
  text-align:center;
}
.mask-dialog img{
  width: 5.98rem;
  height: 3.31rem;
}
.btn{
  position:absolute;
  top:3.31rem;
  left:.85rem;
  line-height:.88rem;
}
.mask-new{
  width: 4.27rem;
  height: .88rem;
  background: #008095;
  box-shadow: inset -5px -5px 10px 0px rgba(125, 194, 209, 0.5);
  border-radius: 60px;
  font-size: .36rem;
  font-weight: 400;
  color: #FFFFFF;
}
.mask-old{
  width: 4.27rem;
  height: .88rem;
  font-size: .36rem;
  font-weight: 400;
  color: #008095;
  margin-top:.18rem;
}
.van-cell{
  line-height: normal;
}
</style>



// WEBPACK FOOTER //
// src/view/home/index.vue